import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Stack} from 'views/components';

import FormStep from './steps/FormStep';
import FormStepper from './components/FormStepper';
import {ExperienceForm, ContactForm} from './intake_forms';

import {useNavigate} from 'react-router-dom';

import backend from 'utils/backend';

const NON_DIGIT_REGEX = /[^0-9]/g;

const Form = (props) => {
  const {statusProgressWrap: progressWrap} = props;

  const [forms, setForms] = React.useState([]);
  const [currentFormIndex, setCurrentFormIndex] = React.useState(0);
  const [authEmail, setAuthEmail] = React.useState('');
  const [bioQuestions, setBioQuestions] = React.useState([]);
  const navigate = useNavigate();

  const handleFormComplete = (formAnswers = {}) => {
    const isLastForm = currentFormIndex >= forms.length - 1;
    if (isLastForm) {
      progressWrap(async () => {
        try {
          const email = (formAnswers.email || authEmail || '').trim();
          const phoneNumber = (formAnswers.phoneNumber || '').replace(NON_DIGIT_REGEX, '');
          const firstName = (formAnswers.firstName || '').trim();
          const lastName = (formAnswers.lastName || '').trim();
          const payload = {
            email,
            phoneNumber,
            firstName,
            lastName,
            bioQuestions: [...bioQuestions, ...(formAnswers.bioQuestions || [])],
          };

          await backend.caregiver.createCaregiverFromForm(payload);
        } catch (e) {}
      });

      navigate(`/welcome?email=${encodeURIComponent(authEmail)}`, {state: {initialEmail: authEmail}});
      return;
    }
    setBioQuestions(formAnswers.bioQuestions || []);
    setCurrentFormIndex((idx) => idx + 1);
  };

  const handleEmailCaptured = (email) => {
    if (!email) return;
    setAuthEmail(email);
  };

  React.useEffect(() => {
    const baseForms = [
      ExperienceForm,
      ContactForm,
    ];
    setForms(baseForms);
  }, []);

  return (
    <Box
      sx={{
        background: 'linear-gradient(180deg, #F6F2EF 0%, #F4EFEA 100%)',
        minHeight: '100dvh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflowX: 'clip',
      }}
    >
      <Stack
        paddingBottom={{xs: 8, sm: 20}}
      >
        <Stack spacing={{xs: 1, sm: 2}} marginTop={{xs: 4, sm: 8}} marginBottom={{xs: 4, sm: 10}}>
          <FormStepper
            forms={forms}
            currentFormIndex={currentFormIndex}
          />

        </Stack>
        <Box
          width={{md: 576, xs: '100%'}}
          maxWidth={{md: 576, xs: '100%'}}
          marginX='auto'
        >
          <FormStep
            forms={forms}
            currentFormIndex={currentFormIndex}
            onFormComplete={handleFormComplete}
            onEmailCaptured={handleEmailCaptured}
            statusProgressWrap={progressWrap}
          />
        </Box>
      </Stack>
    </Box>
  );
};

Form.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, dispatch)(React.memo(Form));

